import {startTriggerTrack} from 'actions/index.js';
import {stopTriggerTrack} from 'actions/index.js';
import {setChordSelected} from 'actions/index.js';
import {CHORD_ON_EVENT} from 'chords/constants.js';
import {CHORD_OFF_EVENT} from 'chords/constants.js';
import Notes from 'midi/Notes.js';
import ChordsManager from 'chords/ChordsManager.js';
import {INSTRUMENT, SAMPLER, AUDIO, MIDI} from 'constants/track-types.js';

class KeyboardHelper {
    constructor(sequencerEngine, keyboardEngine) {
        this.chordsManager = new ChordsManager();
        this.sequencerEngine = sequencerEngine;
        this.store = this.sequencerEngine.store;
        this.keyboardEngine = keyboardEngine;
        this.recordedTriggers = {};
        this.notesDown = new Set();
    }

    onNoteDown(message, isMidi=false, inputName, velocity=null) {
        if (isMidi) {
            this.addNoteOn(message);
        }
        if (!(message in this.recordedTriggers)) {
            // plays the hit
            let resolution = this.store.getState().sequencer.resolution;
            let quantized = this.store.getState().sequencer.quantized;

            this.keyboardEngine.onKeyDown(
                message, resolution, !this.sequencerEngine.rolling, isMidi, inputName, velocity);

            // records the hit
            var recordedTrigger = this.keyboardEngine.recordHit(
                message, isMidi, resolution, quantized, inputName, velocity);


            if (recordedTrigger != null) {
                if ('tracks' in recordedTrigger) {
                    recordedTrigger.recordedTriggers.forEach(
                        trigger => {
                            trigger.release = this.release;
                            let track = this.sequencerEngine.tracks[trigger.trackNumber];
                            this.sequencerEngine.rollingManager
                                .addTrackSlice(trigger.trackNumber, 0, recordedTrigger.transpose);
                            this.store.dispatch(startTriggerTrack(trigger.trackNumber, trigger.sliceNumber));
                        });
                } else {
                    this.sequencerEngine.rollingManager
                        .addTrackSlice(recordedTrigger.trackNumber, recordedTrigger.sliceNumber);

                    // we have a trackNumber so lets tell the UI to flash that track
                    this.store.dispatch(startTriggerTrack(recordedTrigger.trackNumber, recordedTrigger.sliceNumber));
                }

                this.recordedTriggers[message] = recordedTrigger;
            }
        }
    }

    onAlphabetKeyDown(event) {
        this.onNoteDown(event.key, false);
    }

    addNoteOn(note) {
        return;;
        this.notesDown = new Set(this.notesDown);
        this.notesDown.add(note);

        let event = new Event(CHORD_ON_EVENT);
        event.notesDown = this.notesDown;
        window.dispatchEvent(event);
        /*
        if (this.store.getState().selector.showChordFilter) {
            // then we set the chords to be the notes that are down
            let notes = Array.from(this.notesDown).map(
                note => Notes.fromString(note).note);
            this.store.dispatch(setChordSelected(notes));
        }
        */
    }

    addNoteOff(note) {
        return;;
        if (this.notesDown.has(note)) {
            this.notesDown = new Set(this.notesDown);
            this.notesDown.delete(note);
        }

        let event = new Event(CHORD_OFF_EVENT);
        event.notesDown = this.notesDown;
        window.dispatchEvent(event);
    }

    onNoteOff(message, isMidi=false) {
        if (isMidi) {
            this.addNoteOff(message);
        }
        if (message in this.recordedTriggers) {
            var recordedTrigger = this.recordedTriggers[message];

            if (recordedTrigger.tracks !== undefined) {
                // recordedTriggers has the field 'tracks' when we are in
                // computer keyboard mode, and thus can trigger multiple
                // tracks at once

                // first tell the visual feedback for a "track being played"
                // to stop
                recordedTrigger.recordedTriggers.forEach(
                    trigger => 
                        this.store.dispatch(stopTriggerTrack(trigger.trackNumber, trigger.sliceNumber)));
                            
                // if "ROLL" is ON then we must stop the tracks from
                // rolling since this is the key UP event (i.e. the
                // user is removing their finger from the keyboard)
                recordedTrigger.recordedTriggers
                    .filter(trigger => trigger.rolling)
                    .forEach(
                        trigger => {
                            let track = trigger.track;
                            //track.midiEffects.removeNote(recordedTrigger.transpose);
                            this.sequencerEngine.rollingManager.removeTrackSlice(
                                trigger.trackNumber,
                                0, // slice number is 0 here
                                recordedTrigger.transpose);
                        });
                recordedTrigger.tracks
                    .filter(track => track.trackData)
                    .filter(track => !track.rolling)
                    .forEach(track => {
                        //track.midiEffects.removeNote(recordedTrigger.transpose);
                        this.releaseAndRecord(track, recordedTrigger, message, true);
                    });
            } else {
                var track = this.sequencerEngine.tracks[recordedTrigger.trackNumber];
                if (track === undefined) {
                    return;
                }
                this.sequencerEngine.rollingManager.removeTrackSlice(
                    recordedTrigger.trackNumber,
                    recordedTrigger.sliceNumber,
                    undefined);

                this.store.dispatch(stopTriggerTrack(recordedTrigger.trackNumber, recordedTrigger.sliceNumber));

                if (!track.rolling) {
                    this.releaseAndRecord(track, recordedTrigger, message);
                }
            }
            delete this.recordedTriggers[message];
        }
    }

    onKeyUp(event) {
        this.onNoteOff(event.key);
    }

    releaseAndRecord(track, recordedTrigger, note, addTranspose=false) {
        let transpose = recordedTrigger.transpose;

        if (transpose === undefined) {
            transpose = track.trackData.transpose;
        }
        track.midiEffects.liveInputRelease(
            addTranspose ? transpose + track.trackData.transpose : transpose,
            recordedTrigger.sliceNumber);

        if (track.sequencerEngine.playing &&  this.store.getState().sequencer.isRecording ||
            (track.subSequence.isTrack && this.store.getState().mix.isRecordingMix)) {
            recordedTrigger.record(this.sequencerEngine);
        }
    }
}


export default KeyboardHelper;
